<template>
  <div class="row">
    <div
      id="services"
      class="col-xl-6"
    >
      <!--begin::Portlet-->
      <div class="m-portlet m-portlet--rounded m-portlet--head-sm">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                Login As
              </h3>
            </div>
          </div>
        </div>
        <div class="m-portlet__body">
          <form @submit.prevent="loginAs">
            <div class="row">
              <label class="col-xl-12 col-form-label">
                UserName: <small>(*)</small>
              </label>
              <div class="col-xl-9 col-lg-7 col-md-8 col-sm-8 col-12">
                <input
                  v-model="login"
                  type="text"
                  name="AgentRef"
                  class="form-control m-input m-input--solid"
                  placeholder="AIXAA"
                  required
                >

                <span class="m-form__help">
                  <small>Enter the username to login with</small>
                </span>
              </div>
              <div class="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-12">
                <button
                  type="submit"
                  class="btn btn-block btn-primary"
                >
                  Login
                </button>
              </div>
            </div>
          </form>
        </div>

        <!--end::Form-->
      </div>
      <!--end::Portlet-->
    </div>
  </div>
</template>

<script>
import { getUserFromToken } from '../../../functions.ts';
import { adminauthapi } from '../../../api-clients/admin-auth-api.js';
import { i18n } from '../../../i18n.js';
import Cookie from 'js-cookie';

export default {
    data() {
        return {
            login: '',
        };
    },
    mounted() {
        if ( this.$route.query.login ) {
            this.login = this.$route.query.login;
            return this.loginAs();
        }
    },
    methods: {
        async loginAs() {
            mApp.block( 'body', { 'message': i18n.global.t( 'common.LoadingDataPleaseWait' ) } );

            let result = await adminauthapi.post( '/internal/loginasclient', { login: this.login } );

            if ( result.status === 403 ) {
                swal( {
                    title: '',
                    html: i18n.global.t( 'error.server.ErrUserNotAuthorized' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                } );
                mApp.unblock( 'body' );
                return;
            }

            Cookie.set( 'access_token', result.data.accessToken, { expires: 3,
                sameSite: 'Strict' } );
            Cookie.set( 'refresh_token', result.data.refreshToken, { expires: 3,
                sameSite: 'Strict' } );

            // you can now redirect user
            await this.$router.replace( this.$route.query.redirect ? this.$route.query.redirect : '/dashboard' );

            let user = getUserFromToken( result.data.accessToken );
            toastr.success( this.$t( 'Dashboard.welcomeMsg', { userName: user.TradeName || user.CompanyName } ) );

            mApp.unblock( 'body' );
        },
    },
};

</script>
